import { Model } from '@/models/Model';
export class StudentDocumentTemplate extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'StudentDocumentTemplate';
        this.$endpoint = '/student-document-templates';
        this.$fillable = [];
    }
}
export var StudentDocumentTemplateIncludes;
(function (StudentDocumentTemplateIncludes) {
    StudentDocumentTemplateIncludes["BLOCKS"] = "blocks";
})(StudentDocumentTemplateIncludes || (StudentDocumentTemplateIncludes = {}));
export var DocumentableType;
(function (DocumentableType) {
    DocumentableType["PROJECT"] = "project";
    DocumentableType["GROUP"] = "group";
    DocumentableType["USER"] = "user";
})(DocumentableType || (DocumentableType = {}));
